import i18next from "i18next";

const validation = (values) => {
    const errors = {};

    if (!values.name) {
        errors.name = [i18next.t('%{field} is required', {field: i18next.t('Name')})];
    }

    if (!values.url) {
        errors.url = [i18next.t('%{field} is required', {field: i18next.t('Url')})];
    }

    if (values.email) {
        if (!/^[a-zA-Z0-9._-]+$/.test(values.email)) {
            errors.email = [i18next.t('Only letters, numbers, dots, hyphens, and underscores are allowed')];
        } else if (values.email.length > 64) {
            errors.email = [i18next.t('Email prefix cannot be longer than 64 characters')];
        }
    }

    return errors;
};

export default validation;